import { Injectable } from '@angular/core';
import { CheckPlatformService } from './check-platform.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(private checkPlatformService: CheckPlatformService) {}

  public SetItem(key: string, value: string) {
    this.checkPlatformService.isBrowser() && localStorage.setItem(key, value);
  }

  public GetItem(key: string) {
    return this.checkPlatformService.isBrowser() ? localStorage.getItem(key) : null;
  }

  public RemoveItem(key: string) {
    this.checkPlatformService.isBrowser() && localStorage.removeItem(key);
  }

  /** Clears localStorage; optional keys are read before clear and written back (e.g. MFA trusted device id). */
  public ClearAllItems(preserveKeys: string[] = []) {
    if (!this.checkPlatformService.isBrowser()) {
      return;
    }
    const snapshot: Record<string, string> = {};
    for (const key of preserveKeys) {
      if (!key) {
        continue;
      }
      const v = localStorage.getItem(key);
      if (v != null) {
        snapshot[key] = v;
      }
    }
    localStorage.clear();
    for (const [k, v] of Object.entries(snapshot)) {
      localStorage.setItem(k, v);
    }
  }
}
